import { render, staticRenderFns } from "./supporter-criteria-list.vue?vue&type=template&id=7a212ebc&scoped=true&"
import script from "./supporter-criteria-list.vue?vue&type=script&lang=ts&"
export * from "./supporter-criteria-list.vue?vue&type=script&lang=ts&"
import style0 from "./supporter-criteria-list.vue?vue&type=style&index=0&id=7a212ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a212ebc",
  null
  
)

export default component.exports